import axios from 'axios';
import config from '../config';

export const getRouteCardPdfDownloadLink = (routeCardId: string): Promise<string> => {
    const url = `${config.API_URL}/route-cards/${routeCardId}/pdf-download-link`;
    return axios.get(url).then((response: any) => {
        return response.data.data.presigned_url;
    });
};
